import Seo from "@/components/feature/Seo";
import { SITE_URL } from "@/utils/site";
import { faqs } from "@/mocks/faq";
import Hero from "@/pages/home/components/Hero";
import TodayTopic from "@/pages/home/components/TodayTopic";
import BoardGrid from "@/pages/home/components/BoardGrid";
import HotTopics from "@/pages/home/components/HotTopics";
import CommunityValues from "@/pages/home/components/CommunityValues";
import Testimonials from "@/pages/home/components/Testimonials";
import FaqSection from "@/pages/home/components/FaqSection";
import CtaBanner from "@/pages/home/components/CtaBanner";

export default function Home() {
  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: "瓜田社区",
      url: `${SITE_URL}/`,
      inLanguage: "zh-CN",
      description:
        "瓜田社区是汇聚今日话题、热帖推荐与讨论版精华内容的中文线上社区，支持发帖互动与回帖讨论。",
      potentialAction: {
        "@type": "SearchAction",
        target: {
          "@type": "EntryPoint",
          urlTemplate: `${SITE_URL}/topics?q={search_term_string}`,
        },
        "query-input": "required name=search_term_string",
      },
    },
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "瓜田社区",
      url: `${SITE_URL}/`,
      email: "hi@guatian-community.example",
      description: "一个认真说话的线上唠嗑现场，围绕今日话题与讨论版展开交流。",
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqs.map((faq) => ({
        "@type": "Question",
        name: faq.q,
        acceptedAnswer: {
          "@type": "Answer",
          text: faq.a,
        },
      })),
    },
  ];

  return (
    <>
      <Seo
        title="瓜田社区 - 今日话题与热帖推荐，讨论版发帖互动回帖讨论"
        description="来瓜田社区看最新热帖、参与今日话题讨论，这里汇聚海量吃瓜群众，实时更新讨论版精华内容，支持发帖互动与回帖讨论，无论追热点还是聊日常都能找到同好。"
        keywords="瓜田社区,瓜田社区讨论版,瓜田社区今日话题,瓜田社区热帖推荐,瓜田社区发帖互动,瓜田社区回帖讨论,瓜田社区大家聊"
        path="/"
        jsonLd={jsonLd}
      />
      <Hero />
      <TodayTopic />
      <BoardGrid />
      <HotTopics />
      <CommunityValues />
      <Testimonials />
      <FaqSection />
      <CtaBanner />
    </>
  );
}